import React, { useState } from 'react';
import { GroundMountedDashboard } from '../components/FaultIntelligence';

const FaultIntelligencePage: React.FC = () => {
  const [selectedPlant, setSelectedPlant] = useState('1'); // Default plant ID
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto">
        {/* Page Header with Controls */}
        <div className="bg-white dark:bg-gray-800 border-b p-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
                Fault Intelligence & Operational Alerting
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Real-time monitoring and alert management system
              </p>
            </div>
            
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 dark:text-gray-400">Plant:</label>
                <select
                  value={selectedPlant}
                  onChange={(e) => setSelectedPlant(e.target.value)}
                  className="px-3 py-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 text-sm"
                >
                  <option value="1">PRSP_HRJNGL</option>
                  <option value="2">Aviyur 10MW</option>
                </select>
              </div>
              
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 dark:text-gray-400">Date:</label>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="px-3 py-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 text-sm"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Content */}
        <GroundMountedDashboard 
          plantId={selectedPlant} 
          selectedDate={selectedDate}
        />
      </div>
    </div>
  );
};

export default FaultIntelligencePage;